import React, { ReactNode } from 'react';
import { classes } from '@ardoq/common-helpers';
import { CONDITIONAL_IMAGE_COLORING_CLASS_NAME } from '@ardoq/global-consts';
import styled, { css } from 'styled-components';
import {
  TIMELINE_LABEL_CONTAINER_PADDING_X,
  OTHER_LABEL_VERTICAL_MARGIN,
} from '../consts';
import { text2, text2Bold } from '@ardoq/typography';
import { shadowS, colors } from '@ardoq/design-tokens';

const ItemLabelContainer = styled.div<{ $isVertical?: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  z-index: 2;
  padding: ${TIMELINE_LABEL_CONTAINER_PADDING_X}px;
  overflow: hidden;
  content-visibility: auto;
  .forExport & {
    content-visibility: visible;
  }
  ${text2}
  ${({ $isVertical }) =>
    $isVertical &&
    css`
      flex-direction: column;
      gap: ${OTHER_LABEL_VERTICAL_MARGIN}px;
      align-items: flex-start;
    `}
`;

const GroupLabelContainer = styled(ItemLabelContainer)`
  border-radius: 4px;
  box-shadow: ${shadowS};
  background-color: ${colors.white950};
  ${text2Bold};
  color: ${colors.grey950};
`;

const ItemLabelRelativeContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`;

type ItemLabelStylesWrapperProps = {
  isGroupLabel?: boolean;
  children: ReactNode;
  excluded: boolean;
  labelContainerProps: {
    onMouseEnter: () => void;
    onMouseLeave?: () => void;
  };
  withOtherLabels?: boolean;
  style?: React.CSSProperties;
};

export const ItemLabelStylesWrapper = ({
  children,
  isGroupLabel,
  excluded,
  labelContainerProps,
  withOtherLabels,
  style,
}: ItemLabelStylesWrapperProps) => (
  <ItemLabelRelativeContainer
    className={classes('component', CONDITIONAL_IMAGE_COLORING_CLASS_NAME)}
    style={{
      ...style,
      opacity: excluded ? 0.5 : 'unset',
    }}
    {...labelContainerProps}
  >
    {isGroupLabel ? (
      <GroupLabelContainer $isVertical={withOtherLabels}>
        {children}
      </GroupLabelContainer>
    ) : (
      <ItemLabelContainer $isVertical={withOtherLabels}>
        {children}
      </ItemLabelContainer>
    )}
  </ItemLabelRelativeContainer>
);
